export const getLoginId = (state) => state.rootReducer.loginDetails.loginId;
export const getPin = (state) => state.rootReducer.loginDetails.pin;
export const getSocialLoginDetails = (state) => state.rootReducer.socialAuth;
export const getUserDetails = (state) => state.rootReducer.loginDetails;
export const getUserType = (state) => state.rootReducer.loginDetails.userType;
